const TREND_RANGES = [
  { value: '24h', label: 'Daily' },
  { value: '7d', label: 'Weekly' },
  { value: '30d', label: 'Monthly' },
];

const DETAIL_TABLE_RANGES = [
  { value: '24h', label: 'Daily' },
  { value: '7d', label: 'Weekly' },
  { value: '30d', label: 'Monthly' },
  { value: 'all_time', label: 'All Time' },
];

export function getTrendRangeLabel(value) {
  return TREND_RANGES.find((range) => range.value === value)?.label || 'Monthly';
}

export function TrendRangeTabs({ value, onChange, className = '' }) {
  return (
    <div className={`grid grid-cols-3 rounded-xl bg-secondary p-1 ${className}`} aria-label="Trend time range">
      {TREND_RANGES.map((range) => (
        <button
          key={range.value}
          type="button"
          onClick={() => onChange(range.value)}
          className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${
            value === range.value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {range.label}
        </button>
      ))}
    </div>
  );
}

export function DetailTableRangeTabs({ value, onChange, className = '' }) {
  return (
    <div className={`grid grid-cols-4 rounded-xl bg-secondary p-1 ${className}`} aria-label="Detail table time range">
      {DETAIL_TABLE_RANGES.map((range) => (
        <button
          key={range.value}
          type="button"
          onClick={() => onChange(range.value)}
          className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${
            value === range.value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {range.label}
        </button>
      ))}
    </div>
  );
}
